import type { ReactNode } from "react";

import type { WPAccordionCollection } from "../../../../models/WPContentBlock";
import type { WPProductConfig } from "../../../../models/WPProductConfig";

export async function fetchAccordionCollection(
  model: WPAccordionCollection,
  product: WPProductConfig | undefined,
  isAuthorized: boolean,
): Promise<ReactNode> {
  const { AccordionCollection } = await import(
    "../../../components/blocks/AccordionCollection/AccordionCollection"
  );

  return (
    <AccordionCollection
      model={model}
      product={product}
      isAuthorized={isAuthorized}
    />
  );
}
